<style>
</style>

<script>
  import ahoy from 'ahoy.js'
  import { onMount, getContext, setContext } from 'svelte'
  import { writable } from 'svelte/store'
  import { settings, createCart, cart } from '../src/data_storage.js'
  settings.useLocalStorage()
  cart.useLocalStorage()
  import { createGetRequest, createPostRequest, createDeleteRequest } from '../src/create_request'
  import { Router, Link, Route, navigate } from "../rout"
  import { listen as addListener } from '../rout'
  import Shop from "./shop.svelte"
  import Kich from "./kich.svelte"
  import Cart from "./cart/cart.svelte"
  import CartIcon from './cart/svg/cart.svelte'
  import CloseCartIcon from './cart/svg/close_cart.svelte'
  import Orders from "./orders.svelte"
  import Webpage from "./webpage.svelte"
  import Activation from "./activation.svelte"
  import Login from "./login.svelte"
  import UserIcon from '../src/svg/user.svelte'
  import LocaleSelect from '../src/locale_select.svelte'
  import { userauth } from '../src/userauth.js'
  import { formatCurrency } from '../src/utils'
  import {_, locale, locales} from 'svelte-i18n'
  import { initLocale } from '../src/i18n.js'
  initLocale()

  export let name = 'Fronternal'
  export let shop
  export let controllerName = "shops"
  export let controllerAction = "index"
  export let userId

  const Klocale = 'en-US'
  const Kcurrency = 'USD'

  let menuDroppedDown = false
  let signedIn = false
  let showFooter = false

  let showCart = false
  let showActivation = false
  let total = 0

  let y = 0 // window.scrollY

  let basepath = "/" + shop.slug

  addListener(({ location }) => {
    console.log(location.pathname)

    menuDroppedDown = false
  })

  // Share the scroll position with all children
  setContext('app', { getScrollY, imageUrl, theme })

  function theme() {
    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)")
    if (darkThemeMq.matches) {
      return 'dark'
    } else {
      return 'light'
    }
  }

  function getScrollY() {
    return y
  }

  function imageUrl(absolutePath) {
    return import.meta.env.BASE_URL + absolutePath
  }

  setContext('cart', { addItem, removeItem, cartTotal })
  if (!$cart[shop.id]) {
    $cart[shop.id] = {items: []}
  }

  function addItem(kich, shop) {
    if (!$cart[shop.id].items) {
      $cart[shop.id].items = []
    }

    const alreadyAdded = $cart[shop.id].items.find(item => item.id === kich.id)
    if (alreadyAdded) {
      return
    }

    $cart[shop.id].items.push(kich)
    $cart = $cart

    if ($cart[shop.id].currentOrder) {
      if ($cart[shop.id].items && $cart[shop.id].items.length) {
        // update order
        fetch(createPostRequest('/cart/checkout_update.json',
                            'POST',
                            JSON.stringify({ order: { items: $cart[shop.id].items.map((kich) => kich.id)}, slug: shop.slug, order_id: $cart[shop.id].currentOrder.id})))
          .then(response => response.json())
          .then(data => {
            console.log('removeItem:' + shop.slug)
            console.log(data)
            if (data.errors) {
              alert(data.errors)
            } else if (data.id) {
              $cart[shop.id].currentOrder = data
            } else {
              alert("Something went wrong, try again later.")
            }
          })
          .catch(err => {
            alert('error ' + err)
          })
      }
    }
  }

  function removeItem(kich, shop) {
    $cart[shop.id].items = $cart[shop.id].items.filter((item) => item.id !== kich.id)

    if  ($cart[shop.id].currentOrder !== null) {
      if ($cart[shop.id].items && $cart[shop.id].items.length) {
        // update order
        fetch(createPostRequest('/cart/checkout_update.json',
                            'POST',
                            JSON.stringify({ order: { items: $cart[shop.id].items.map((kich) => kich.id)}, slug: shop.slug, order_id: order.id})))
          .then(response => response.json())
          .then(data => {
            console.log('removeItem:' + shop.slug)
            console.log(data)
            if (data.errors) {
              alert(data.errors)
            } else if (data.id) {
              $cart[shop.id].currentOrder = data
            } else {
              alert("Something went wrong, try again later.")
            }
          })
          .catch(err => {
            alert('error ' + err)
          })
      } else {
        // destroy currentOrder
        // update order
        fetch(createPostRequest('/cart/checkout_delete.json',
                            'POST',
                            JSON.stringify({ slug: shop.slug, order_id: $cart[shop.id].currentOrder.id})))
          .then(response => response.json())
          .then(data => {
            console.log('removeItem:' + shop.slug)
            console.log(data)
            if (data.errors) {
              alert(data.errors.email)
            } else {
              $cart[shop.id].currentOrder = null
            }
          })
          .catch(err => {
            alert('error ' + err)
          })


        $cart[shop.id].currentOrder = null
      }
    }
  }

  function cartTotal(shop) {
    return $cart[shop.id].items.filter((item) => item.kind === 'tangible').reduce((partialSum, { price }) => partialSum + +(price), 0)
  }

  function handle_order_submitted() {
    showCart = false
    fetchShop()
  }

  function handle_menu_click(app, route = '') {
    menuDroppedDown = false

    saveSettings()
  }

  function handle_emptied_cart() {
    showCart = false
  }

  function handle_signin(event) {
    if (event.detail.text === 'signedin') {
      $userauth = event.detail.user_session
      console.log('handle_signin:')
      console.log($userauth)
      $cart[shop.id].activationSent = false
      $cart[shop.id].activated = false

      //window.history.pushState('root', 'root', '/' + shop.slug);
      navigate(basepath)
    }
  }

  function handle_signout(event) {
    fetch(createDeleteRequest('/user_sessions.json'))
      .then(response => {
        signOut()
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  function signOut() {
    // console.log('handle_signout:')
    $userauth = null
    showCart = false
    navigate(basepath)
  }

  function mountUserFromData(data, pushState = false) {
    // console.log('fronternal mountUserFromData')
    //console.log(data)
    $userauth = data['user_session']
    // console.log($userauth)
    ahoy.track('fronternal mount')
  }

  function fetchUserSession() {
    // console.log("fetchUserSession")
    // fetch user session
    fetch(createGetRequest('/user_sessions.json'))
      .then(response => response.json())
      .then(data => {
        if (data['user_session']) {
          mountUserFromData(data) // we have a previous session, we're logged in
        } else {
          console.log('no user session!')
          console.log(data)
          console.log('no user session!')
          // need to tune back in; we don't have a previous session
          if ($userauth !== null) {
            $userauth = null
          }
        }

      })
      .catch(err => {
        $userauth = null
        alert('error ' + err)
      })
  }

  function fetchShop() {
    // console.log('fetchShop')
    fetch(createGetRequest(basepath))
      .then(response => response.json())
      .then(data => {
        if (data['id']) {
          shop = data
          // console.log('shop:')
          // console.log(shop)
        } else {
          console.log('no shop data!')
          console.log(data)
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  function saveSettings() {
    // console.log('saveSettings: showCart: ' + showCart)
    $settings.showCart = showCart
  }

  function loadSettings() {
    $settings.locale = $locale // TODO: use shop settings or determine locale auto
    $settings.currency = $_('currency')

    showCart = $settings.showCart
  }

  onMount(async () => {
    console.log('fronternal')
    // console.log(shop)
    // console.log('webpages:')
    // console.log(shop.webpages)
    // console.log(settings)
    // console.log(localStorage.getItem("settings"))

    // const base_url = import.meta.env.BASE_URL
    // console.log('BASE_URL: ' + base_url)
    // const href = window.location.href
    // console.log("location.href: " + href)
    // const path = window.location.pathname
    // console.log("location.pathname: " + path)
    basepath = "/" + shop.slug
    console.log('basepath: ' + basepath)

    loadSettings()
    fetchShop()

    if (controllerName === 'user_activations' && controllerAction === 'new') {
      showActivation = true
    } else {
      fetchUserSession()
    }
  })

  function toggleCart() {
    showCart = !showCart

    saveSettings()

    if (showCart && menuDroppedDown) {
      menuDroppedDown = false
    }
  }

  function hideCart() {
    showCart = false

    saveSettings()
  }

  $: total = ($cart[shop.id] && $cart[shop.id].items.length) ? cartTotal(shop) : 0
  $: signedIn = $userauth !== null
  $: signedinInfo = signedIn ? $userauth.name : ''
  //$: console.log(y)
</script>

<svelte:window bind:scrollY={y} />

{#if shop.webpages}
  <div class="eter" eternalname={name}>
    <Router {basepath}>

      <header id="header" class="flex">

        <div class="header-logo flex flex-row">
          <a class="logo flex items-center justify-center" href="#">
            {#if shop.logo_light && shop.logo_dark}
              <img class="hidden dark:block h-[37px]" src={shop.logo_dark.src} alt="logo">
              <img class="block dark:hidden h-[37px]" src={shop.logo_light.src} alt="logo">
            {:else}
              <img class="hidden dark:block h-[37px]" src="{imageUrl('all/logo-alt-dark.png')}" alt="logo">
              <img class="block dark:hidden h-[37px]" src="{imageUrl('all/logo-alt.png')}" alt="logo">
            {/if}
          </a>
          <div class="header-title font-bold flex items-center justify-center text-sm sm:text-lg">
            <Link to="./" on:click={hideCart}>{shop.meta_title}</Link>
          </div>
        </div>

        <div class="grow"></div>

        <div class="header-info mr-1 flex flex-col items-center justify-center text-xs sm:text-sm">
          {#if signedinInfo}
            <span class="hidden md:block">{signedinInfo}</span>
            <UserIcon title="{signedinInfo}"/>
          {/if}
        </div>

        <div id="cart-button" class="header-cart py-1 flex items-center justify-center" on:click={toggleCart}>

          <div class="">
            {#if total > 0}
              {formatCurrency(total, $settings.locale, $settings.currency, 2, 0)}
            {/if}
          </div>

          <div class="flex flex-col items-center justify-end">
            {#if $cart[shop.id] && $cart[shop.id].items.length}
              <div class="flex items-center justify-center text-xs">{$cart[shop.id].items.length || ''}</div>
            {/if}
            {#if showCart}
              <CloseCartIcon />
            {:else}
              <CartIcon />
            {/if}
          </div>
        </div>

        <div class="header-menu flex flex-row items-center">

          <nav id="nav">

            <input class="trigger peer" type="checkbox" id="mainNavButton" bind:checked={menuDroppedDown} on:click={hideCart}/>
            <label for="mainNavButton" class="relative block mx-1 lg:hidden"></label>

            <ul class="absolute hidden bg-white dark:bg-[#272727] peer-checked:flex peer-checked:flex-row peer-checked:flex-wrap peer-checked:min-h-32 peer-checked:place-content-center peer-checked:space-x-4 peer-checked:my-4 peer-checked:shadow peer-checked:right-0 peer-checked:top-10 peer-checked:w-screen lg:relative lg:flex lg:flex-row lg:flex-wrap lg:justify-end lg:mt-0">

              {#if signedIn}
                <li><div class="underline p-1 flex items-center justify-center"><Link to="./" on:click={hideCart}>{$_('shop')}</Link></div></li>
                <li><div class="underline p-1 flex items-center justify-center"><Link to="orders" on:click={hideCart}>{$_('orders')}</Link></div></li>
                {#if shop.webpages}
                  {#each shop.webpages as webpage}
                    {#if webpage.slug}
                      <li><div class="underline p-1 flex items-center justify-center"><Link to="{webpage.slug}" on:click={hideCart}>{webpage.title}</Link></div></li>
                    {/if}
                  {/each}
                {/if}
                <li><div class="underline p-1 flex items-center justify-center"><a on:click|preventDefault={handle_signout} href="/">{$_('signout')}</a></div></li>
              {:else}
                <li><div class="underline p-1 flex items-center justify-center"><Link to="signin" on:click={hideCart}>{$_('signin')}</Link></div></li>
                <li><div class="underline p-1 flex items-center justify-center"><Link to="./" on:click={hideCart}>{$_('shop')}</Link></div></li>
                {#if shop.webpages}
                  {#each shop.webpages as webpage}
                    {#if webpage.slug}
                      <li><div class="underline p-1 flex items-center justify-center"><Link to="{webpage.slug}" on:click={hideCart}>{webpage.title}</Link></div></li>
                    {/if}
                  {/each}
                {/if}
              {/if}
              <li>
                <div class="p-1 flex items-center justify-center">
                  <div class="p-1">{$_('symbol')}</div>
                  <LocaleSelect class="dark:text-black"/>
                </div>
              </li>

            </ul>

          </nav>

        </div>
      </header>

      <main>
        {#if showCart}<Cart {shop} bind:signedIn bind:showCart on:signin={handle_signin} order_done_handler={handle_order_submitted} emptied_handler={handle_emptied_cart}/>{/if}

        <Route path="">{#if !showCart}<Shop {shop}/>{/if}</Route>
        <Route path="/orders">{#if !showCart}<Orders {shop}/>{/if}</Route>
        {#each shop.webpages as webpage}
          <Route path="/{webpage.slug}">{#if !showCart}<Webpage {shop} {webpage}/>{/if}</Route>
          {#each webpage.blogs as blog}
            <Route path="/{webpage.slug}/{blog.slug}">{#if !showCart}<Webpage {shop} {webpage} {blog}/>{/if}</Route>
          {/each}
        {/each}
        {#each shop.kichboxes as kichbox}
          {#each kichbox.kiches as kich}
            <Route path="/{kich.slug}">{#if !showCart}<Shop {shop} {kich}/>{/if}</Route>
          {/each}
        {/each}
        {#if showActivation}
          <Route path="/user/register/*"><Activation {shop} {userId}/></Route>
        {/if}
        <Route path="/signin"><Login on:signin={handle_signin}/></Route>
      </main>
    </Router>
  </div>
  {#if showFooter}
    <footer>
      <div class="map">
        <a on:click|preventDefault={() => handle_menu_click('PagesApp', 'contact')} href="/contact">Contact</a>
        <a on:click|preventDefault={() => handle_menu_click('PagesApp', 'about')} href="/about">About</a>
        {#if tunedIn}
          <a on:click|preventDefault={handle_tuneup} href="/tuneup">Tune up a Guru?</a>
        {/if}
      </div>
      &copy; 2020 <a href='manitu.si'>Manitu</a> All Rights Reserved
    </footer>
  {/if}
{:else if shop.id === 0}
  <div class="flex flex-col justify-center items-center mt-8">
    <span class="font-bold">{shop.title}</span>
    <div class="mt-4 text-xs flex flex-row justify-center font-semibold">Loading eternalfriend webshop experience failed.</div>
    <div class="mt-12 text-xs flex flex-row justify-center btn"><a href="/">Find another shop or create '{shop.slug}' shop --> click here!</a></div>
  </div>
{:else}
  <div class="flex flex-col justify-center items-center mt-8">
    <span class="font-bold">{shop.title}</span>
    <div class="mt-4 text-xs flex flex-row justify-center">Loading eternalfriend webshop experience...</div>
  </div>
{/if}